<template>
  <div>
    <v-dialog
      :value="!!confirmacion"
      max-width="420"
      content-class="dialogo-confirmar"
      @input="(abierto) => !abierto && responder(false)"
      @keydown.enter="responder(true)"
    >
      <v-card v-if="confirmacion" class="rounded-xl">
        <v-card-title class="subtitle-1 font-weight-bold">
          <v-icon left :color="confirmacion.peligro ? 'error' : 'primary'">{{ confirmacion.icono }}</v-icon>
          {{ confirmacion.titulo }}
        </v-card-title>
        <v-card-text v-if="confirmacion.texto" class="text-body-2 texto-confirmar">{{ confirmacion.texto }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="responder(false)">{{ confirmacion.cancelar }}</v-btn>
          <v-btn :color="confirmacion.peligro ? 'error' : 'primary'" depressed @click="responder(true)">
            {{ confirmacion.aceptar }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :key="aviso ? aviso.id : 0"
      :value="!!aviso"
      :color="colorAviso"
      :timeout="aviso && aviso.tipo === 'error' ? 6000 : 3500"
      top
      rounded="pill"
      class="aviso-global"
      @input="(v) => !v && cerrarAviso()"
    >
      <v-icon left small color="white">{{ iconoAviso }}</v-icon>
      {{ aviso && aviso.texto }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" aria-label="Cerrar aviso" @click="cerrarAviso"><v-icon small>mdi-close</v-icon></v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { estadoDialogos } from "@/plugins/dialogos";

const AVISOS = {
  success: { color: "success", icono: "mdi-check-circle" },
  error: { color: "error", icono: "mdi-alert-circle" },
  warning: { color: "orange darken-2", icono: "mdi-alert" },
  info: { color: "grey darken-3", icono: "mdi-information" },
};

export default {
  name: "DialogosGlobales",
  computed: {
    confirmacion() {
      return estadoDialogos.confirmacion;
    },
    aviso() {
      return estadoDialogos.aviso;
    },
    colorAviso() {
      return (AVISOS[this.aviso?.tipo] || AVISOS.info).color;
    },
    iconoAviso() {
      return (AVISOS[this.aviso?.tipo] || AVISOS.info).icono;
    },
  },
  methods: {
    responder(valor) {
      const c = estadoDialogos.confirmacion;
      if (!c) return;
      estadoDialogos.confirmacion = null;
      c.resolver(valor);
    },
    cerrarAviso() {
      estadoDialogos.aviso = null;
    },
  },
};
</script>

<style scoped>
.texto-confirmar {
  white-space: pre-line;
}
</style>
